var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"countdown"},[_c('div',{staticClass:"block"},[_c('div',{staticClass:"digit"},[(_vm.text)?_c('div',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.time)+" ")]},null,{ time: _vm.time })],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }